import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import lodash from "lodash";

import SelectTemplate from "./SelectTemplate";
import Attachment from "../../Attachment";

class EmailForm extends React.Component {
  render() {
    const {
      files,
      templates,
      options,
      selectedUser,
      subject,
      message,
      onChangeSelectUsers,
      onChangeInput,
      onSelectTemplate,
      onDropFile,
      onDeleteFile
    } = this.props;

    return (
      <div>
        <div className="mb-15">
          <label htmlFor="recipient-select">To *</label>
          <Select 
            isMulti
            styles={{
              menuList: (base, state) => ({ ...base, maxHeight: 250 }),
              placeholder: (base) => ({ ...base, color: "#595959" })
            }}
            className="custom-react-select"
            value={selectedUser}
            options={options}
            inputId="recipient-select"
            ariaLabel="recipient-select"
            onChange={onChangeSelectUsers}
          />
        </div>

        <div>
          <label>Subject</label>
          <input
            className="form-control"
            type="text"
            name="__subject"
            placeholder="Employee Announcement"
            value={subject}
            onChange={onChangeInput}
            aria-label= "subject"
          />
        </div>

        <SelectTemplate
          data={lodash.filter(templates, { message_type: "E-Mail" })}
          onSelect={onSelectTemplate}
        />

        <div>
          <label>Message *</label>
          <textarea
            cols="5"
            rows="3"
            className="form-control"
            placeholder="Message to employees..."
            name="__message"
            value={message}
            onChange={onChangeInput}
          />
        </div>

        <div className="mb-15">
          <span className="dark-grey-text">
            **Bold** - *Italic* - [Link Title](https://digiquatics.com) * Bullets
            <br />
            <a
              className="styled-link"
              target="_blank"
              href="https://help.digiquatics.com/product-questions/how-to-format-text-in-digiquatics-using-markdown"
            >
              View Markdown tips
            </a>
          </span>
        </div>

        <div>
          <Attachment
            labelId={"messaging-email-form-attachment-label"}
            accept="*/*"
            files={files}
            onDropFile={onDropFile}
            onDelete={onDeleteFile}
          />
        </div>
      </div>
    );
  }
}

EmailForm.propTypes = {
  files: PropTypes.array,
  templates: PropTypes.array,
  options: PropTypes.array,
  selectedUser: PropTypes.array,
  subject: PropTypes.string,
  message: PropTypes.string,
  onChangeSelectUsers: PropTypes.func,
  onChangeInput: PropTypes.func,
  onSelectTemplate: PropTypes.func,
  onDropFile: PropTypes.func,
  onDeleteFile: PropTypes.func
};

export default EmailForm;
